















































import {Component, Vue} from "vue-property-decorator";
import Header from "@/components/public/Header.vue";
import Footer from "@/components/public/Footer.vue";
import InvestorItem from "@/components/InvestorItem.vue";
@Component({
  components:{
    'Header': Header,
    'Footer': Footer,
    'investor-item': InvestorItem,
  }
})

export default class Investor extends Vue{

  // 项目列表tabs
  private activeName:any=''

  private investor:any=[];        //破产项目
  private pageInfo:any={
    page: 1,
    size: 12,
    total: 0
  };
  private loading:boolean=false;

  created(){
    this.getProjects()
  }

  public getProjects() {
    this.loading = true;
    let params = {
      ...this.pageInfo
    }
    this.axios.get( this.$URL.INVESTOR_LIST, { params }).then((res:any)=>{
      console.log( res.data, '1' )
      this.investor = res.data.list
      this.pageInfo.total = res.data.total
      this.loading = false;
    })
  }

  public handleSizeChange(size:any) {
    this.pageInfo.size = size
  }

  public handleCurrentChange(page:any) {
    this.pageInfo.page = page
    const section = document.getElementById('investor');
    if(section){
      section.scrollIntoView({ behavior: 'smooth' });
    }
    this.getProjects()
  }

}
